import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=dcbfa342&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbfa342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcbfa342')) {
      api.createRecord('dcbfa342', component.options)
    } else {
      api.reload('dcbfa342', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=dcbfa342&scoped=true&", function () {
      api.rerender('dcbfa342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4WCkzjDt3JOCb/JS/comp/Accordion.vue"
export default component.exports